import React, { useReducer } from 'react';
import { node, shape, arrayOf, string, number } from 'prop-types';
import RestaurantsContext from './restaurant-context';

import restaurantsReducer from './restaurants-reducer';
import actionCreators from './action-creators';
import buildInitialState from './build-initial-state';

const { Provider } = RestaurantsContext;

const RestaurantsProvider = ({ data, distance, children }) => {
  data.sort((a, b) => {
    const firstRestaurant = a.shortName.toUpperCase();
    const secondRestaurant = b.shortName.toUpperCase();

    return firstRestaurant.localeCompare(secondRestaurant);
  });
  const [state, dispatch] = useReducer(restaurantsReducer, buildInitialState(data, distance));

  return (
    <Provider
      value={{
        ...state,
        dispatch: actionCreators(dispatch),
      }}
    >
      {children}
    </Provider>
  );
};

RestaurantsProvider.propTypes = {
  data: arrayOf(
    shape({
      restaurantId: string.isRequired,
      address: shape({
        line1: string.isRequired,
        city: string.isRequired,
        postalCode: string,
      }).isRequired,
      name: string.isRequired,
      shortName: string.isRequired,
      coordinates: shape({
        latitude: number.isRequired,
        longitude: number.isRequired,
      }).isRequired,
    })
  ).isRequired,
  distance: number.isRequired,
  children: node.isRequired,
};

export default RestaurantsProvider;
